// extracted by mini-css-extract-plugin
export var loadingShimmer = "_rh-2";
export var messageContent = "_rh-0";
export var messagesScroll = "_rh-1";
export var shimmer = "_rh-3";
export var shimmerW100 = "_rh-4";
export var shimmerW70 = "_rh-8";
export var shimmerW80 = "_rh-7";
export var shimmerW85 = "_rh-6";
export var shimmerW90 = "_rh-5";